var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8665_35463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7144 4.5H6.21436C5.66207 4.5 5.21436 4.94772 5.21436 5.5V10C5.21436 10.5523 5.66207 11 6.21436 11H10.7144C11.2666 11 11.7144 10.5523 11.7144 10V5.5C11.7144 4.94772 11.2666 4.5 10.7144 4.5Z",
    stroke: "url(#paint0_linear_8665_35463)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.21436 7.5H2.71436C2.44914 7.5 2.19479 7.39464 2.00725 7.20711C1.81971 7.01957 1.71436 6.76522 1.71436 6.5V2C1.71436 1.73478 1.81971 1.48043 2.00725 1.29289C2.19479 1.10536 2.44914 1 2.71436 1H7.21436C7.47957 1 7.73393 1.10536 7.92146 1.29289C8.109 1.48043 8.21436 1.73478 8.21436 2V2.5",
    stroke: "url(#paint1_linear_8665_35463)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8665_35463",
    x1: 5.8616,
    y1: 3.15095,
    x2: 12.5102,
    y2: 3.65436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFB09C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B75556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8665_35463",
    x1: 2.3616,
    y1: -0.349055,
    x2: 9.01025,
    y2: 0.154362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFB09C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B75556"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8665_35463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.714355)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.13941e185692b81a04bf6141fee3b9ab.svg";
export { ForwardRef as ReactComponent };